import { getWxConfig } from '@/api/wxConfig'

const wechat = {
  state: {
    config: {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: '', // 必填，公众号的唯一标识
      timestamp: '', // 必填，生成签名的时间戳
      nonceStr: '', // 必填，生成签名的随机串
      signature: '', // 必填，签名
      jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
    }
  },

  mutations: {
    SET_CONFIG: (state, data) => {
      state.config.appId = data.appId
      state.config.timestamp = data.timestamp
      state.config.nonceStr = data.nonceStr
      state.config.signature = data.signature
    },
    SET_DEBUG: (state) => {
      state.config.debug = !state.config.debug
    }
  },

  actions: {
    getConfig ({ commit }, urlObj) {
      return new Promise((resolve, reject) => {
        getWxConfig(urlObj).then(response => {
          let data = response.data
          if (data.code === 0) {
            commit('SET_CONFIG', data.result)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setDebug ({commit}) {
      commit('SET_DEBUG')
    }
  }
}

export default wechat



// WEBPACK FOOTER //
// ./src/store/modules/wechat.js